/*
Starting here and Continuing until Noted all code is provided with RESTRICTED RIGHTS:

Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/

import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.benchmarks = 'http://localhost:2080/';

export default new (class BenchmarksService {
  // Benchmarks API
  async fetchBenchmarks(payload) {
    return await axiosInstance
      .post(`${envUrls.benchmarks}compute`, payload)
      .then((response) => {
        return response.data;
      });
  }

  // Get any custom sets associated with this scan
  async getCustomSetData(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.get(
      `${envUrls.benchmarks}custom_sets/${payload}`,
      { headers: headers }
    );
    return response.data;
  }
  // Create new custom benchmarks set
  async createCustomSet(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.benchmarks}custom_sets`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  // Create new custom benchmarks set
  async editCustomSet(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.patch(
      `${envUrls.benchmarks}custom_sets`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  // Delete existing custom benchmarks set
  async deleteCustomSet(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.delete(
      `${envUrls.benchmarks}custom_sets/${payload}`,
      { headers: headers }
    );
    return response.data;
  }
  // Get a list of institutions for the custom set modal
  async getInstitutions(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.benchmarks}institutions`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
})();

/*
Ending here, all code as  noted above is provided with RESTRICTED RIGHTS:

Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/
